import React from 'react';
import { CalendarRangePicker } from '@shared/components/CalendarRangePicker';
import { pxToRem } from '@withjoy/joykit/theme';
import { Box } from '@withjoy/joykit';
import { useFormattedDate } from '@shared/hooks/useFormattedDate';

interface DateRangeFieldsProps {
  label: { startDate: string; endDate: string };
  value?: { startDate?: Date | null; endDate?: Date | null };
  appendPickerToBody?: boolean;
  onChange: ([startDate, endDate]: Readonly<[Date | undefined, Date | undefined]>) => void;
  isDisabled?: boolean;
  enableCloseOnSelection?: boolean;
}

export const DateRangeFields = ({ label, value, appendPickerToBody, onChange, isDisabled, enableCloseOnSelection }: DateRangeFieldsProps) => {
  const formattedStartDate = useFormattedDate(value?.startDate, 'weekday-short, MMM d') ?? '';
  const formattedEndDate = useFormattedDate(value?.endDate, 'weekday-short, MMM d') ?? '';

  return (
    <CalendarRangePicker
      closeOnSelectDate={enableCloseOnSelection}
      isDisabled={isDisabled}
      initial={[value?.startDate ?? undefined, value?.endDate ?? undefined]}
      onChange={onChange}
      appendPickerToBody={appendPickerToBody}
    >
      <Box
        width="100%"
        display={'grid'}
        backgroundColor={isDisabled ? 'mono4' : 'white'}
        gridColumn={'1 / 3'}
        gridTemplateColumns={'1fr 1fr'}
        cursor="pointer"
        border="1px solid"
        borderColor="mono5"
        borderRadius={pxToRem(8)}
      >
        <Box
          paddingY={pxToRem(12)}
          paddingX={pxToRem(16)}
          display={'flex'}
          flexDirection={'column'}
          gap={pxToRem(4)}
        >
          <Box typographyVariant={'label3'}>{label.startDate}</Box>
          <Box
            typographyVariant={'body2'}
            fontSize={15}
          >
            {formattedStartDate}
          </Box>
        </Box>
        <Box
          borderLeft="1px solid"
          borderColor="mono5"
          paddingY={pxToRem(12)}
          paddingX={pxToRem(16)}
          display={'flex'}
          flexDirection={'column'}
          gap={pxToRem(4)}
        >
          <Box typographyVariant={'label3'}>{label.endDate}</Box>
          <Box
            typographyVariant={'body2'}
            fontSize={15}
          >
            {formattedEndDate}
          </Box>
        </Box>
      </Box>
    </CalendarRangePicker>
  );
};
